"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _domAlign = _interopRequireDefault(require("dom-align"));
var _react2 = require("../utils/react");
var _placement = _interopRequireWildcard(require("./placement"));
var _helper = require("./helper");
var _configProvider = require("../config-provider/configProvider");
var _menu = _interopRequireDefault(require("../menu"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 使用 forwardRef 使父组件可以访问 Dropdown 内部的 ref
var Dropdown = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$placement = _ref.placement,
    propPlacement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1030 : _ref$zIndex,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    content = _ref.content,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    children = _ref.children,
    onVisibleChange = _ref.onVisibleChange,
    controlledVisible = _ref.visible,
    propClassName = _ref.className,
    getContainer = _ref.getContainer,
    _ref$autoDestroy = _ref.autoDestroy,
    autoDestroy = _ref$autoDestroy === void 0 ? false : _ref$autoDestroy,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? false : _ref$arrow,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    customAlign = _ref.align;
  var _useState = (0, _react.useState)(controlledVisible || false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1]; // 控制 Dropdown 的可见性
  var triggerRef = (0, _react.useRef)(null); // 持有 Trigger 组件的引用
  var popRefArrow = (0, _react.useRef)(null); // 持有箭头元素的引用
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls; // 获取前缀 class
  var PREFIX = getPrefixCls('dropdown');
  (0, _react.useEffect)(function () {
    if (controlledVisible !== undefined) {
      setIsVisible(controlledVisible); // 如果 controlledVisible 有变化，更新 isVisible
    }
  }, [controlledVisible]);
  // 处理对齐逻辑
  var handleAlign = function handleAlign(align, popNode) {
    if (triggerRef.current) {
      var popLayerContainer = triggerRef.current.popRef.current.popLayerContainer;
      var arrowNode = (0, _react2.findDOMNode)(popRefArrow.current);
      var targetNode = (0, _react2.findDOMNode)(triggerRef.current);
      if (popNode && arrowNode && targetNode) {
        var reachedLimit = (0, _helper.isReachLimit)(popNode, window, {
          popNodeAlign: align
        }) || (0, _helper.isReachLimit)(popNode, popLayerContainer, {
          popNodeAlign: align
        });
        if (arrowNode) {
          if (reachedLimit) {
            var arrowAlign = (0, _helper.adjustArrowAlign)(align);
            (0, _domAlign.default)(arrowNode, targetNode, arrowAlign);
            adjustClass(arrowAlign, arrowNode);
          } else {
            arrowNode.style.cssText = '';
          }
        }
        adjustClass(align, popNode);
      } else if (!targetNode) {
        console.warn('targetNode is null. if you are using react version 18 or above, the child must be inside a DOM element.');
      }
    }
  };
  // 处理可见性变化
  var handleVisibleChange = function handleVisibleChange(visible) {
    if (controlledVisible === undefined) {
      setIsVisible(visible);
    }
    onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(visible);
  };
  // 获取菜单元素
  var getMenuElement = function getMenuElement() {
    var _content$props;
    var contentProps = {
      className: (0, _classnames.default)(content === null || content === void 0 || (_content$props = content.props) === null || _content$props === void 0 ? void 0 : _content$props.className, "".concat(PREFIX, "-menu"), "".concat(PREFIX, "-menu-").concat(size) // 根据 size 设置 className
      ),
      onSelectChange: onSelectChange,
      prefixCls: "".concat(PREFIX, "-menu"),
      size: size,
      align: customAlign !== null && customAlign !== void 0 ? customAlign : {
        offset: [8, -4]
      }
    };
    var contentEle = content;
    if ((0, _react2.isValidChild)(content, [_menu.default])) {
      contentEle = /*#__PURE__*/_react.default.cloneElement(content, contentProps);
    }
    var dropdownCls = (0, _classnames.default)(PREFIX, propClassName, (0, _defineProperty2.default)({}, "".concat(PREFIX, "-show-arrow"), arrow), "".concat(PREFIX, "-light"));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: dropdownCls,
      style: style
    }, arrow && ( /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "-arrow"),
      ref: popRefArrow
    })), contentEle);
  };
  // 处理Menu的选择事件
  var onSelectChange = function onSelectChange(key, item, e) {
    var _content$props$onSele, _content$props2;
    if (controlledVisible === undefined) {
      setIsVisible(false);
    }
    (_content$props$onSele = (_content$props2 = content.props).onSelectChange) === null || _content$props$onSele === void 0 || _content$props$onSele.call(_content$props2, key, item, e);
  };
  // 获取对齐配置
  var getAlignConfig = function getAlignConfig() {
    var finalPlacement = _objectSpread({}, _placement.default[propPlacement]);
    if (arrow) {
      finalPlacement = _objectSpread({}, _placement.placementsWithArrow[propPlacement]);
    }
    return finalPlacement;
  };
  // 获取对齐时的类名
  var getAlignPopupClassName = function getAlignPopupClassName(align) {
    var points = align.points;
    var cls = '';
    Object.keys(_placement.default).forEach(function (placementKey) {
      if ((0, _react2.isPointsEq)(_placement.default[placementKey].points, points)) {
        cls = "".concat(PREFIX, "-placement-").concat(placementKey);
      }
    });
    return cls;
  };
  // 调整类名
  var adjustClass = function adjustClass(align, popNode) {
    var placementCls = getAlignPopupClassName(align);
    Array.prototype.forEach.call(popNode.classList, function (className) {
      var reg = new RegExp("^".concat(PREFIX, "-placement-\\w+"));
      if (reg.test(className)) {
        popNode.classList.remove(className);
      }
    });
    placementCls && popNode && popNode.classList.add(placementCls);
  };
  // 暴露 forceAlign 方法
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      // 重新定位弹窗
      forceAlign: function forceAlign() {
        var _triggerRef$current;
        (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.forceAlign();
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement(_react2.Trigger, {
    ref: triggerRef,
    className: (0, _classnames.default)(PREFIX, (0, _defineProperty2.default)({}, "".concat(PREFIX, "-disabled"), disabled)),
    trigger: trigger,
    popup: getMenuElement(),
    align: getAlignConfig(),
    onAlign: handleAlign,
    visible: !disabled && isVisible,
    onVisibleChange: handleVisibleChange,
    getContainer: getContainer,
    autoDestroy: autoDestroy,
    zIndex: zIndex,
    CSSTransitionName: "".concat(PREFIX, "-menu"),
    timeout: 300
  }, children);
});
Dropdown.displayName = 'Dropdown';
var _default = exports.default = Dropdown;